import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ElectricSubSectionDetail from './SubUtilityDetailsSections/ElectricSubSectionDetail';
import NaturalGasSubSectionDetail from './SubUtilityDetailsSections/NaturalGasSubSectionDetail';
import WasteWaterSubSectionDetail from './SubUtilityDetailsSections/WasteWaterSubSectionDetail';
import WaterSubSectionDetail from './SubUtilityDetailsSections/WaterSubSectionDetail';
import TelecommunicationsSubSectionDetail from './SubUtilityDetailsSections/TelecommunicationsSubSectionDetail';
import ConditionalWrapper from '../../ConditionalWrapper/ConditionalWrapper';
import { PROPERTY_TYPES } from '../../../constants';

// Ensure the utility has at least one valid supplierName
function testSupplierName(utility) {
  let result;
  for (let i = 0; i < utility.length; i += 1) {
    if (utility[i] && utility[i].supplierName && utility[i].supplierName !== null && utility[i].supplierName !== '') {
      result = true;
      break;
    }
  }

  return result;
}

export class PropertyDetailUtilitiesComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { showUtilityDetails: false };
  }

  componentWillReceiveProps(nextProps) {
    this.setStateFromProps(nextProps);
  }

  setStateFromProps(fromProps) {
    const { showDetailsTab } = fromProps;
    if (!showDetailsTab && this.state.showUtilityDetails) {
      // this.props.updateDetailsTab(this.state.showUtilityDetails);
      if (typeof this.props.updateDetailsTab === 'function') {
        this.props.updateDetailsTab(this.state.showUtilityDetails);
      }
    }
  }

  render() {
    const {
      electric,
      naturalGas,
      water,
      wasteWater,
      telecommunications,
    } = this.props.property.utilities;
    const electricList = Array.isArray(electric) ? electric : [electric];
    const gasList = Array.isArray(naturalGas) ? naturalGas : [naturalGas];
    const waterList = Array.isArray(water) ? water : [water];
    const wasteWaterList = Array.isArray(wasteWater) ? wasteWater : [wasteWater];
    const telecommunicationsList = Array.isArray(telecommunications)
      ? telecommunications : [telecommunications];

    const isBuilding = this.props.type === PROPERTY_TYPES.BUILDINGS;
    const detailSectionsToShow = isBuilding ?
      this.props.viewer.buildingSettings.detailSectionsToShow :
      this.props.viewer.siteSettings.detailSectionsToShow;

    const showElectric = (testSupplierName(electricList)
      && (!detailSectionsToShow || detailSectionsToShow.includes('Electric Service')));
    const showNaturalGas = testSupplierName(gasList)
      && (!detailSectionsToShow || detailSectionsToShow.includes('Natural Gas Service'));
    const showWasteWater = (testSupplierName(wasteWaterList)
      && (!detailSectionsToShow || detailSectionsToShow.includes('Sewer Service')));
    const showWater = (testSupplierName(waterList)
      && (!detailSectionsToShow || detailSectionsToShow.includes('Water Service')));
    const showTelecommunications = (testSupplierName(telecommunicationsList)
      && (!detailSectionsToShow || detailSectionsToShow.includes('Telecommunications Service')));

    this.state.showUtilityDetails = (showElectric || showNaturalGas ||
      showWasteWater || showWater || showTelecommunications);

    return (
      <div>
        <ConditionalWrapper condition={showElectric} >
          <ElectricSubSectionDetail title="Electric Service" util={electricList} />
        </ConditionalWrapper>

        <ConditionalWrapper condition={showNaturalGas} >
          <NaturalGasSubSectionDetail title="Natural Gas" util={gasList} />
        </ConditionalWrapper>

        <ConditionalWrapper condition={showWater} >
          <WaterSubSectionDetail title="Water" util={waterList} />
        </ConditionalWrapper>

        <ConditionalWrapper condition={showWasteWater} >
          <WasteWaterSubSectionDetail title="Wastewater" util={wasteWaterList} />
        </ConditionalWrapper>

        <ConditionalWrapper condition={showTelecommunications} >
          <TelecommunicationsSubSectionDetail title="Telecommunications" util={telecommunicationsList} />
        </ConditionalWrapper>
      </div>
    );
  }
}

PropertyDetailUtilitiesComponent.propTypes = {
  type: PropTypes.string.isRequired,
  property: PropTypes.object.isRequired,
  viewer: PropTypes.object.isRequired,
  updateDetailsTab: PropTypes.func,
};

export default PropertyDetailUtilitiesComponent;



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetailUtilities/PropertyDetailUtilities.js